import { overlay_backgroundNotFocused, white100 } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { modal_transitionSpeed } from 'ext-ui/style/transitionSpeeds'
import { css } from 'styled-components'

export default css`
  .BaseModal-Content {
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;

    overflow-y: auto;
    max-height: 100vh;

    &:focus-visible {
      /* It is obvious that the modal has focus, b/c it is in the foreground */
      outline: none;
    }

    .BaseModal-CloseButton {
      position: absolute;
      top: ${spacing(-12)};
      right: ${spacing(-2)};

      &:hover {
        cursor: pointer;
      }
    }

    .BaseModal-Body {
      background-color: ${white100};
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
      border-radius: 10px;
    }

    /* VARIANTS */
    &.popup {
      width: 678px;

      .BaseModal-Body {
        padding: ${spacing(15)};
      }
    }

    &.interactive {
      width: 519px;
    }
  }

  /* Transition (both content and overlay fade) */
  .BaseModal-Overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;

    background-color: ${overlay_backgroundNotFocused};
    opacity: 0;
    transition: opacity ${modal_transitionSpeed} ease-in-out;

    &.BaseModal-Overlay-open {
      opacity: 1;
    }
    &.BaseModal-Overlay-closed {
      opacity: 0;
    }
  }
`
